import React from 'react';
import { PortExtendedInnerInner } from '@ais-ui/api-spec/portserver';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@ais-ui/ui-core';
import {
  PiDotsThreeVertical,
  PiPencil,
  PiTrash,
  PiPolygon,
} from 'react-icons/pi';

interface InnerAreaItemProps {
  area: PortExtendedInnerInner;
  index: number;
  onEdit: (index: number) => void;
  onDelete: (index: number) => void;
}

export const InnerAreaItem = React.memo(
  ({ area, index, onEdit, onDelete }: InnerAreaItemProps) => {
    return (
      <div className="flex items-center justify-between p-2 rounded-md border hover:bg-accent/50 transition-colors cursor-default">
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <PiPolygon className="size-4 text-muted-foreground shrink-0" />
          <div className="min-w-0 flex-1">
            <span className="text-sm font-medium truncate block">
              {area.name || `Area ${index + 1}`}
            </span>
            {area.terminalType && (
              <span className="text-xs text-muted-foreground">
                {area.terminalType}
              </span>
            )}
          </div>
        </div>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="size-8 shrink-0">
              <PiDotsThreeVertical className="size-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => onEdit(index)}>
              <PiPencil className="size-4 mr-2" />
              Edit
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => onDelete(index)}
              className="text-destructive focus:text-destructive"
            >
              <PiTrash className="size-4 mr-2" />
              Delete
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
  },
);

InnerAreaItem.displayName = 'InnerAreaItem';
